module.exports = {"371724001":"凤凰街道","371724002":"永丰街道","371724101":"龙固镇","371724102":"大义镇","371724103":"柳林镇","371724104":"章缝镇","371724105":"大谢集镇","371724106":"独山镇","371724107":"麒麟镇","371724108":"核桃园镇","371724109":"田庄镇","371724110":"太平镇","371724111":"万丰镇","371724112":"陶庙镇","371724113":"董官屯镇","371724114":"田桥镇","371724115":"营里镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/371724.json
// module id = 1384
// module chunks = 0